import adapter from '../adapter-static-page-v2';
import { siteIDs } from '../../../adapters/utils';
var SchemaTypes = adapter.SchemaTypes;
var schema = {
    '@context': 'https://schema.org/',
    '@type': 'LocalBusiness',
    name: "{{" + siteIDs.BUSINESS_NAME + "}}",
    url: "{{" + siteIDs.SITE_URL + "}}",
    image: "{{" + siteIDs.BUSINESS_SCHEMA_IMAGE + "}}",
    address: {
        '@type': 'PostalAddress',
        addressCountry: "{{" + siteIDs.BUSINESS_LOCATION_COUNTRY + "}}",
        addressLocality: "{{" + siteIDs.BUSINESS_LOCATION_CITY + "}}",
        addressRegion: "{{" + siteIDs.BUSINESS_LOCATION_STATE + "}}",
        postalCode: "{{" + siteIDs.BUSINESS_POSTAL_CODE + "}}",
        streetAddress: "{{" + siteIDs.BUSINESS_LOCATION_STREET_ADDRESS + "}}",
    },
    telephone: "{{" + siteIDs.BUSINESS_PHONE + "}}",
};
export default {
    type: SchemaTypes.LOCAL_BUSINESS,
    schema: schema,
};
